

































































































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

import ProductForm from './ProductForm/ProductForm.vue';
import uniq from 'lodash/uniq';
import ProductContainerForm from './ProductContainerForm/ProductContainerForm.vue';
import StructureTab from './StructureTab/StructureTab.vue';

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar,
    StructureTab
  }
})
export default class ProductDirectory extends Vue {
  opened: any[] = [];
  activeTab: number = 0;

  get titleStack () {
    return [
      'Справочник продуктов',
      this.activeTab === 1 ? 'Структура' : 'Продукты'
    ]
  }

  onTabChange(tabIndex: number) {
    console.debug('[ProductDirectory.onTabChange]', { tabIndex });
    if (tabIndex === 1) {
      const structureTab: any = this.$refs.structureTab;
      if (structureTab && typeof structureTab.reload === 'function') {
        structureTab.reload();
      }
    }
  }

  openStructureType() {
    const structureTab: any = this.$refs.structureTab;
    if (structureTab && typeof structureTab.openProductType === 'function') {
      structureTab.openProductType(null, null);
    }
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  private delayFilter: any = null

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...filter
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  openProduct(row: any) {
    this.$buefy.modal.open({
      component: ProductForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  productArchive(row: any) {
    this.$store.dispatch(`${STORE_KEY}/productToArchive`, row.id)
      .then((result) => {
        this.$buefy.snackbar.open(`Продукт помечен архивным`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  productUnarchive(row: any) {
    this.$store.dispatch(`${STORE_KEY}/productToUnarchive`, row.id)
      .then((result) => {
        this.$buefy.snackbar.open(`Продукт помечен активным`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  openProductContainer(row: any, product: any) {
    this.$buefy.modal.open({
      component: ProductContainerForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: product ? {
          product_id: product.id
        } : {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  productContainerArchive(row: any) {
    this.$store.dispatch(`${STORE_KEY}/productToArchive`, row.id)
      .then((result) => {
        this.$buefy.snackbar.open(`Тара помечена архивной`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  productContainerUnarchive(row: any) {
    this.$store.dispatch(`${STORE_KEY}/productToUnarchive`, row.id)
      .then((result) => {
        this.$buefy.snackbar.open(`Тара помечена активной`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
      console.debug('[ProductDirectory.created] registered store module', { STORE_KEY });
    }
  }

  public mounted() {
    console.debug('[ProductDirectory.mounted] start', { query: this.$route.query });
    this.handleParamsChange();
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

  public beforeDestroy() {
    console.debug('[ProductDirectory.beforeDestroy] unregister store module', { STORE_KEY });
    this.$store.unregisterModule(STORE_KEY);
  }

  @Watch('$route.query')
  public handleParamsChange() {
    console.debug('[ProductDirectory.handleParamsChange]', { query: this.$route.query });
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
